import { css } from '@emotion/css';

export const largeUserAbsolutePictureStyles = css`
  top: 0.7rem;
  left: 0.7rem;
`;

export const imageBorderStyles = css`
  box-shadow: 0 0 0 1px var(--bg-primary);
`;
